import {
  createBoundaryApmRecorder,
  createRootTel,
  type RootTel,
} from '@w/tel'

export const isSensitive = (key: string) =>
  /cookie|token|auth|password|secret|key/iu.test(key)

/**
 * Server root tel without an exporter: request units return to the client through the boundary relay, and the
 * client exports them (flashcards-telemetry.requirements.md 2026-11-01).
 */
export function createFlashcardsServerTel({ env }: { env: string }): RootTel {
  const tel = createRootTel({
    name: 'flashcards-server',
    origin: 'server',
    metricsMode: 'serverless',
    env,
    isSensitive,
  })
  tel.setHandlers(createBoundaryApmRecorder())

  return tel
}
